export function addFullStoryInfo(filterInfo) {
    var _a, _b;
    const fullStoryInfo = {};
    if (window.FS) {
        const fsSessionUrl = (_b = (_a = window.FS).getCurrentSessionURL) === null || _b === void 0 ? void 0 : _b.call(_a, true);
        if (fsSessionUrl) {
            fullStoryInfo.sessionUrl = fsSessionUrl;
        }
        else {
            fullStoryInfo.info = 'FullStory session URL is not available';
        }
    }
    else {
        fullStoryInfo.info = 'FullStory is not available (window.FS is nullish))';
    }
    filterInfo.fullStory = fullStoryInfo;
}



// WEBPACK FOOTER //
// ./node_modules/@doxo/willow-airbrake/dist/esm/filters/add-full-story-info.js